// extracted by mini-css-extract-plugin
export default {"svg":"GearIcon_svg__jlW5X","active":"GearIcon_active__mAa5t"};